import React, { FC } from 'react'

//* utils
import { ModuleNames } from '../../../constants/componentNames.constants'
import { LocaleCodes } from '../../../constants/localization.constants'
import { ComponentAnnouncement } from '../../../models/components/announcement'
import { ComponentMainNavBanner } from '../../../models/components/mainNavBanner'
import { MenuGroup } from '../../../models/others/menuGroup'

//* components
import Hero from '../../../components/global/hero'
import ContentBlock from '../../global/contentBlock'
import ContentColumns from '../../global/contentColumns'
import Divider from '../../global/divider'
import MainCTA from '../../global/mainCta'
import MediaText from '../../global/mediaText'
import RawHTML from '../../global/rawHTML'
import ResourceRow from '../../global/resourceRow'
import SEOTags from '../../global/seoTags'
import VideoSpotlight from '../../global/videoSpotlight'
import Layout from '../../layouts/layout'

type Props = {
  path: string
  pageContext: any
  headerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  footerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  announcementData?: ComponentAnnouncement
  mainNavBannerData?: ComponentMainNavBanner
  browserLanguageData?: any
}

const About: FC<Props> = ({
  path,
  pageContext,
  headerData,
  footerData,
  announcementData,
  mainNavBannerData,
  browserLanguageData,
}) => {
  if (!pageContext.pageData) return null
  const { seoMetaData, node_locale, modules } = pageContext.pageData.data?.contentfulPageFlex

  const dynamicPageContent = modules?.map((module: any, i: number) => {
    switch (module.__typename) {
      case ModuleNames.MEDIA_TEXT:
        return <MediaText data={module} key={`page-component--${i}`}></MediaText>

      case ModuleNames.VIDEO_SPOTLIGHT:
        return <VideoSpotlight data={module} key={`page-component--${i}`}></VideoSpotlight>

      case ModuleNames.GLOBAL_CONTENT_COLUMNS:
        return (
          <ContentColumns
            data={module}
            pageType="careers"
            key={`page-component--${i}`}></ContentColumns>
        )

      case ModuleNames.GLOBAL_CONTENT_BLOCK:
        return <ContentBlock data={module} key={`page-component--${i}`}></ContentBlock>

      case ModuleNames.DIVIDER:
        return <Divider data={module} key={`page-component--${i}`}></Divider>

      case ModuleNames.GLOBAL_MAIN_CTA:
        return <MainCTA data={module} key={`page-component--${i}`}></MainCTA>

      case ModuleNames.ANCHOR_LINK:
        return <span id={module.identifier || ''} key={`page-component--${i}`}></span>

      case ModuleNames.RESOURCE_ROW:
        return (
          <ResourceRow
            data={module}
            locale={node_locale}
            pageType="careers"
            key={`page-component--${i}`}
          />
        )

      case ModuleNames.RAW_HTML:
        return <RawHTML data={module} key={`page-component--${i}`} />
    }
  })

  return (
    <Layout.Template
      lang={LocaleCodes.ENGLISH.code}
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      mainNavBannerData={mainNavBannerData}
      browserLanguageData={browserLanguageData}
      pageType="careers">
      <div data-cy="Careers-AboutPage">
        <SEOTags
          seoMetadata={seoMetaData}
          path={path}
          slug={'/company/careers'}
          locale={node_locale}
        />

        <Hero data={pageContext.heroData} showBreadcrumbs={false} />
        {dynamicPageContent}
      </div>
    </Layout.Template>
  )
}

export default About
